<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>list</mat-icon>
        <div>Inscrições</div>

        <!--
        <a mat-button (click)="insertDoc()" style='width:60px; margin-left:10px;'>
          <mat-icon class='icon_close'>arrow_circle_down</mat-icon>
         </a>
         -->

      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">

      </div>

    </mat-toolbar>

  </mat-card>

  <mat-card style='display:flex; flex-direction: row; justify-content: space-between;'>

    <div  style='display:flex; flex-direction: column;'>
      <label>Selecione um produto</label>
      <mat-select style='width: 800px; margin-top:10px; background-color: whitesmoke; padding: 5px;' (ngModelChange)='selectProductChange($event)' [ngModel]='selectedProduct'>
        <mat-option *ngFor="let product of allProducts" [value]="product.id">
          {{ product.name }}
        </mat-option>
      </mat-select>
    </div>

    <button mat-raised-button style='width:60px; margin: 25px 0 0 20px; height: 35px;' *ngIf="product_id" (click)="refresh()">
      <mat-icon class='icon-done'>refresh</mat-icon>
    </button>

  </mat-card>

  <mat-card>

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>star</mat-icon>
          <div>{{count}} Inscritos</div>
        </ng-template>

        <div *ngIf="byTopicFlag" style="margin: 10px 0 10px 0; padding: 10px; border: solid 1px silver;">
          <div *ngFor="let count of arrayConters" style="display: flex;  flex-direction: row;">

            <div style="width: 30px; padding: 5px 0 5px 0;">{{ count.topic_count }}</div>
            <div style="padding: 5px 0 5px 0;">{{ count.topic_name }}</div>

          </div>
        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="dataSource" matSort #sortMember="matSort" matSortActive="date" matSortDirection='desc'
          matSortDisableClear=true>

          <!-- date Column -->
          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.date.seconds*1000 | date: 'dd/MM/yyyy HH:mm' }}
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style="display:flex; flex-direction:column;">
                <div>{{ element.name }}</div>
                <div *ngIf="element.category == 'Não Sócio'">
                  <div style="color:red;">
                    <i>{{ element.category }}</i>
                  </div>
                </div>
                <div *ngIf="element.category != 'Não Sócio'">
                  <i>{{ element.category }}</i>
                </div>
                <!--  <div style="color:red;">{{ element.nonMemberCategory_id }}</div>-->
                <div *ngIf='element.nonMemberCategory_name' style="color:green;">
                  » {{ element.nonMemberCategory_name }}
                </div>
                <div *ngIf="element.topic_name" style="color:blue;">{{ element.topic_name }}</div>
              </div>
            </mat-cell>
          </ng-container>

          <!-- valid Email Column -->
          <ng-container matColumnDef="validEmail">
            <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <img *ngIf='element.validEmail' src='/assets/images/status/img_green.png'>
              <img *ngIf='!element.validEmail' src='/assets/images/status/img_red.png'>
            </mat-cell>
          </ng-container>

          <!-- email Column -->
          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.email }} </mat-cell>
          </ng-container>

          <!-- valid CPF Column -->
          <ng-container matColumnDef="validCPF">
            <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <img *ngIf='element.validCPF' src='/assets/images/status/img_green.png'>
              <img *ngIf='!element.validCPF' src='/assets/images/status/img_red.png'>
            </mat-cell>
          </ng-container>

          <!-- CPF Column -->
          <ng-container matColumnDef="cpf">
            <mat-header-cell *matHeaderCellDef mat-sort-header> CPF </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.cpf }} </mat-cell>
          </ng-container>

          <!-- gender Column -->
          <ng-container matColumnDef="gender">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Gen </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.gender }} </mat-cell>
          </ng-container>

          <!-- value Column -->
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.value | currency:'BRL':'':'1.2-2' }}
            </mat-cell>
          </ng-container>

          <!-- docStatus Column -->
          <ng-container matColumnDef="docStatus">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Docs. </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.docStatus }}
            </mat-cell>
          </ng-container>

          <!-- Export Column -->
          <ng-container matColumnDef="export">
            <mat-header-cell *matHeaderCellDef>
              <button mat-button style='width:60px;' (click)="exportToCsv()">
                <mat-icon class='icon-close'>arrow_circle_down</mat-icon>
              </button>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;" (click)='openDialog(row)'></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>star</mat-icon>
          <div>{{countStaff}} Staff </div>
        </ng-template>

        <!-- TABLE -->
        <mat-table [dataSource]="dataSourceStaff" matSort #sortStaff="matSort" matSortActive="name"
          matSortDirection='asc' matSortDisableClear=true>

          <!-- photoURL -->
          <ng-container matColumnDef="photoURL">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container>
                <img class='photoURL' [src]='element.image'>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style="display: flex; flex-direction: column;">
                <div> {{ element.name }} </div>
                <div><i> {{ element.subCategory.name }} </i></div>
              </div>
            </mat-cell>
          </ng-container>

          <!-- valid Email Column -->
          <ng-container matColumnDef="validEmail">
            <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <img *ngIf='element.validEmail' src='/assets/images/status/img_green.png'>
              <img *ngIf='!element.validEmail' src='/assets/images/status/img_red.png'>
            </mat-cell>
          </ng-container>

          <!-- email Column -->
          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.email }} </mat-cell>
          </ng-container>

          <!-- valid CPF Column -->
          <ng-container matColumnDef="validCPF">
            <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <img *ngIf='element.validCPF' src='/assets/images/status/img_green.png'>
              <img *ngIf='!element.validCPF' src='/assets/images/status/img_red.png'>
            </mat-cell>
          </ng-container>

          <!-- CPF Column -->
          <ng-container matColumnDef="cpf">
            <mat-header-cell *matHeaderCellDef mat-sort-header> CPF </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.cpf }} </mat-cell>
          </ng-container>

          <!-- gender Column -->
          <ng-container matColumnDef="gender">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Gen </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.sex }} </mat-cell>
          </ng-container>

          <!-- valid Curriculo Column -->
          <ng-container matColumnDef="validText">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Cur </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <img *ngIf='element.validText' src='/assets/images/status/img_green.png'>
              <img *ngIf='!element.validText' src='/assets/images/status/img_red.png'>
            </mat-cell>
          </ng-container>

          <!-- has Subscription Column -->
          <ng-container matColumnDef="subscription">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Ins </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <img *ngIf='element.hasSubscription' src='/assets/images/status/img_green.png'>
              <img *ngIf='!element.hasSubscription' src='/assets/images/status/img_red.png'>
            </mat-cell>
          </ng-container>

          <!-- Export Column -->
          <ng-container matColumnDef="export">
            <mat-header-cell *matHeaderCellDef>
              <button mat-button style='width:60px;' (click)="exportToCsvStaff()">
                <mat-icon class='icon-close'>arrow_circle_down</mat-icon>
              </button>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumnsStaff"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumnsStaff;" (click)='openDialogStaff(row)'></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-tab>


    </mat-tab-group>

  </mat-card>

</div>